import { DiscountRuleRepository } from "public/repository/discount-rule.repository";
import { ProductVariationRepository } from "public/repository/product-variation.repository";
import { ProductRepository } from "public/repository/product.repository";
import { VolumeDiscountRepository } from "public/repository/volume-discount.repository";
import { normalizeProductOptions } from "public/utils/normalize-product-options";
import { replaceNumberWithWildcard } from "public/utils/replace-number-with-wildcard";
import { transformOffersToPreviewData } from "public/utils/transform-offers-to-preview-data";
import { transformVariationItemToPriceMapByAspectKey } from "public/utils/transform-variation-item-to-price-map-by-aspect-key";
import { currentCart } from '@wix/ecom';
import { ecom } from "@wix/site-ecom";



export class ProductView {
  /**
   * @param {Object} settings
   * @param {string} settings.namespace
   * @param {boolean} settings.isPaid
   * @param {boolean} settings.isEditorMode
   * @param {string} settings.productId
   */
  constructor(args) {
    console.log("argsInProductView", args);
    this._isV1Catalog = args.isV1Catalog
    this._volumeDiscountRepository = new VolumeDiscountRepository(args.settings);
    this._productRepository = new ProductRepository({
      isV1Catalog: this._isV1Catalog
    });
    this._productVariationRepository = new ProductVariationRepository();
    this._discountRuleRepository = new DiscountRuleRepository();

    

    this._settings = args.settings;
    this._isSampleData = false;
    this._product = null;
    this._pricePlaceholder = null;
    this._volumeDiscount = null;

    // Elements
    this._blockElement = $w("#volumeDiscountsBlock");
  }

  setSettings(settings) {
    this._settings = settings;
  }

  

  render() {
    if (!this._volumeDiscount || !this._volumeDiscount.offers) {
      console.log(
        "render:volumeDiscount",
        "no volume discount or offers",
        this._volumeDiscount
      );
      return;
    }

    if (!Array.isArray(this._volumeDiscount.offers)) {
      console.log(
        "render:volumeDiscount",
        "offers is not an array",
        this._volumeDiscount
      );
      return;
    }

    if (!this._volumeDiscount.offers.length) {
      console.log(
        "render:volumeDiscount",
        "offers is empty",
        this._volumeDiscount
      );
      return;
    }
    console.log("render:start");

    this.renderOffers();
  }

  renderOffers() {
    console.log("renderOffers:started");

    const priceMapByAspectKey = transformVariationItemToPriceMapByAspectKey({
      variationItems: this._variationItems,
    });

    console.log("variation Items", this._variationItems);
    console.log("Price Map", priceMapByAspectKey);

    const previewOffers = transformOffersToPreviewData({
      offers: this._volumeDiscount.offers,
      product: this._product,
      priceMapByAspectKey,
    });

    const aspects = normalizeProductOptions(this._product.productOptions);

    this._blockElement.setAttribute(
      "block-data",
      JSON.stringify({
        offers: previewOffers,
        aspects,
        priceMapByAspectKey: Object.fromEntries(priceMapByAspectKey.entries()),
        productPrice: this._product.price,
        pricePlaceholder: this._pricePlaceholder,
        title: this._volumeDiscount.block.title,
        addToCartText: this._volumeDiscount.block.addToCartText,
        offerSummaryTitle: this._volumeDiscount.block.offerSummaryTitle,
        offerSummaryTitleStandard:
          this._volumeDiscount.block.offerSummaryTitleStandard,
        isPreview: false,
        isSampleData: this._isSampleData,
        style: this._volumeDiscount.style,
        settings: this._volumeDiscount.settings,
        layout: this._volumeDiscount.block.layout,
      })
    );

    this._blockElement.on("onAddToCartClick", async ({ detail: { data } }) => {
      console.log(`blockElement:onAddToCartClick`, data, previewOffers);

      try {
        this._blockElement.setAttribute("loading-data", true);

        if (!data.selected) {
          throw new Error("Couldn't get selection data");
        }

        const quantity = this._volumeDiscount.settings
          .allowMultipleVariationSelection
          ? 1
          : Number(data.selected.quantity);

        const selectedProducts = data.selected.products.map((product) => {
          return {
            productId: this._product._id,
            quantity,
            options: {
              choices: product.aspects,
            },
          };
        });

        console.log("SELECTEDPRODUCTS", selectedProducts, this._product, this._variationItems);

        const selectedProductsReduced = selectedProducts.reduce((acc, cur) => {
          const aspectsId = JSON.stringify(cur.options);

          acc[aspectsId]
            ? (acc[aspectsId].quantity += cur.quantity)
            : (acc[aspectsId] = cur);
          return acc;
        }, {});

        console.log(
          "blockElement:onAddToCartClick:selectedProductsReduced",
          Object.values(selectedProductsReduced)
        );

        const options = {
          lineItems: await this.transformProductLineItems(Object.values(selectedProductsReduced), this._variationItems)
        };

        console.log("PRODUCTOPTIONS", options);

        const updatedCart = await currentCart.addToCurrentCart(options)
        console.log("blockElement:onAddToCartClick:updatedCart", updatedCart);
        await ecom.refreshCart();

        console.log(
          "blockElement:onAddToCartClick:customClassList:values",
          this._blockElement.classList
        );

        this._blockElement.setAttribute("loading-data", null);
        this._blockElement.setAttribute("success-data", true);

        setTimeout(() => {
          this._blockElement.setAttribute("success-data", null);
        }, 3000);

        ecom.openSideCart();
      } catch (e) {
        console.error("blockElement:onAddToCartClick:error", e);
        this._blockElement.setAttribute("loading-data", null);
      }
    });

    this._blockElement.on("onConsoleLog", ({ detail: { data } }) => {
      console.log(`blockElement:onConsoleLog`, data);
    });

    console.log("renderOffers:finished");
  }

  async setup() {
    await this.setupProduct();
    await this.setupVolumeDiscount();
    await this.setupVariationItems();

    this._pricePlaceholder = replaceNumberWithWildcard(
      this._product.formattedPrice
    );
  }

  compareProductChoicesObject(choices1, choices2){
    const keys1 = Object.keys(choices1);
    const keys2 = Object.keys(choices2);

    if (keys1.length !== keys2.length) return false;

    return keys1.every(key => 
        Object.prototype.hasOwnProperty.call(choices2, key) &&
        choices1[key] === choices2[key]
    );
  }

  findVariantId(choices, variants) {
    const matchingVariant = variants.find(variant =>
      this.compareProductChoicesObject(choices, variant.choices)
    );
    
    if (matchingVariant && matchingVariant._id !== "00000000-0000-0000-0000-000000000000") {
      return matchingVariant._id;
    }

    return null;
  }


  async transformProductLineItems(products, variants){
    const transformedItems = products.map(item => {
        const choices = item.options?.choices || {};
        const variantId = this.findVariantId(choices, variants);
        
        let options = {};
        if (variantId && variantId !== '00000000-0000-0000-0000-000000000000') {
            options.variantId = variantId;
        }
        
        return {
            catalogReference: {
                appId: "215238eb-22a5-4c36-9e7b-e7c08025e04e", 
                catalogItemId: item.productId,
                options: options
            },
            quantity: item.quantity
        };
    });
    return transformedItems;
  }

  async setupVolumeDiscount() {
    console.log("setupVolumeDiscount:started");

    this._isSampleData = false;

    const volumeDiscountByProductId =
      await this._volumeDiscountRepository.getFirstByProductId(
        this._product._id
      );

    const volumeDiscountByApplyTo =
      await this._volumeDiscountRepository.getFirstByApplyTo("ALL_PRODUCTS");

    if (volumeDiscountByProductId && volumeDiscountByApplyTo) {
      this._volumeDiscount =
        volumeDiscountByProductId.createdAt > volumeDiscountByApplyTo.createdAt
          ? volumeDiscountByProductId
          : volumeDiscountByApplyTo;

      console.log(
        "setupVolumeDiscount:volumeDiscount",
        "both",
        this._volumeDiscount
      );
      return;
    }

    if (volumeDiscountByProductId) {
      this._volumeDiscount = volumeDiscountByProductId;
      console.log(
        "setupVolumeDiscount::volumeDiscount",
        "volumeDiscountByProductId",
        this._volumeDiscount
      );
      return;
    }

    this._volumeDiscount = volumeDiscountByApplyTo;

    if (!this._volumeDiscount) {
      if (this._settings.isEditorMode) {
        this._volumeDiscount = this._volumeDiscountRepository.getDummyData();
        this._isSampleData = true;
        console.log(
          "setupVolumeDiscount:volumeDiscount",
          "editMode",
          this._volumeDiscount
        );
        return;
      }

      throw new Error(`Couldn't find deal by product id: ${this._product._id}`);
    }

    console.log("setupVolumeDiscount:volumeDiscount", this._volumeDiscount);
    console.log("setupVolumeDiscount:finished");
  }

  async setupProduct() {
    console.log("setupProduct:started");
    

    try {
      if (!this._settings.productId) {
        throw new Error("Couldn't get product id. Contact support.");
      }

      const product = this._isV1Catalog ? 
        await this._productRepository.findFirstById(this._settings.productId) : 
        await this._productRepository.findFirstById_V3(this._settings.productId);



      if (!product) {
        throw new Error(
          `Couldn't get product data. Contact Support by id ${this._settings.productId}`
        );
      }

      this._product = product;

      console.log("setupProduct:product", this._product);
      console.log("setupProduct:finished");
    } catch (e) {
      console.error("setupProduct:error", e);

      // Probably loading in edit mode
      this._product = this._productRepository.getDummyProduct();

      console.log("setupProduct:edit_mode_load:product", this._product);
    }

    return;
  }

  async setupVariationItems() {
    console.log("setupVariationItems:started");

    try {
      if(this._isV1Catalog){
      this._variationItems =
        await this._productVariationRepository.getVariationItems({
          productId: this._product._id,
        });
      }else{
        this._variationItems =
          await this._productVariationRepository.getVariationItems_V3({
            productId: this._product._id,
          });
      }
    } catch (e) {
      console.error("setupVariationItems:error", e);
        this._variationItems =
          this._productVariationRepository.getDummyVariationItems();

      console.log(
        "setupVariationItems:edit_mode_load:variationItems",
        this._variationItems
      );
    }
  }
}
